class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }
  generateReserveCart(){
   const activateTimer=document.getElementById('activate_timer_cart');
   if(activateTimer && activateTimer.textContent==='false') return;
   if(this.notification.querySelector('.cart-notification__header')&& this.notification.querySelector('.cart-notification__header').textContent !==''){
    const div = document.createElement('div');
    div.classList.add('reserve_cart');
    div.innerHTML=`<div class="reserve_cart_content">
    <p class="reserve_cart_text"></p>
    </div>`
    this.notification.querySelector('.cart-notification__header').after(div);
    this.generateTimer();
   }
  }
  generateTimer() {
    let timeLeft = 5 * 60; // 5 minutes en secondes

    const updateTimer = () => {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;
      
      // Mettez à jour l'affichage du timer ici
      const timerDisplay = this.notification.querySelector('.reserve_cart_content p');
      if (timerDisplay) {
        timerDisplay.innerHTML = `Votre panier est réservé pendant <span style="color:red;">${minutes}min:${seconds.toString().padStart(2, '0')}s</span>`;
      }

      if (timeLeft > 0) {
        timeLeft--;
        setTimeout(updateTimer, 1000);
      } else {
        // Le timer est terminé, on le relance
        this.generateTimer();
      }
    };

    updateTimer();
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
    this.generateReserveCart();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
